export enum StockEventType {
  Sale = 'Sale',
  Order = 'Order',
  Purchase = 'Purchase',
  InternalTransfer = 'Internal Transfer', // When the stock is moving to a location within the supplying entity
  ExternalTransfer = 'External Transfer', // When the stock is moving to a location within the supplying entity, but is part of an order that is a sale
  CancelledSale = 'Cancelled Sale', // For sales that were fulfilled and were cancelled after the fact
  // Below would be part of a manual stock event
  StockTake = 'Stock Take',
  Conversion = 'Conversion',
  Damaged = 'Damaged',
  Lost = 'Lost',
  Other = 'Other',
  StockIn = 'Stock In',
  StockOut = 'Stock Out',
  Production = 'Production',
}

// Sale = 100,
// Order = 200,
// ManualOrder = 201, // The supplier placed an order on behlaf of the customer
// Purchase = 300,
// InternalTransfer = 400, // When the stock is moving to a location within the supplying entity
// ExternalTransfer = 450, // When the stock is moving to a location within the supplying entity, but is part of an order that is a sale
// Delivery = 475, // The Stock was delivered to a customer (Delivery event could be pending meaning its loaded on the truck and pending delivery)
// Collected = 476, // The Stock was collected by the customer from a pickup point
// StockTake = 500, // Physical count of inventory to verify accuracy
// // Below would be part of a manual stock event
// StockIn = 525,
// StockOut = 550,
// Adjustment = 575, //Manual adjustment to inventory levels
// Conversion = 600,
// Production = 625, //  Stock that has been pushed into a site after being produced or manufactured TODO Ensure we dont allow to negative
// CancelledSale = 650,
// ManualFulfill = 651,
// Damaged = 700,
// Returned = 800,
// Lost = 900,
// Other = 1000
